import { MappedImage } from "src/utils/fw";
import { convertLinksUTM, effect, IAMetadata, ISFAssure } from "./dayOne";
import membership from "./membership";
import Podcast from "./Podcast";
import { useEffect } from "preact/hooks";
import { Extra } from "../../explorationZone";
import { dismiss, ModalForm } from "../AIInsightsForm";

const AIInsights = () => {
    useEffect(effect("a9c38cbc-f374-4621-83b2-8de48580bf52"), [])

    const links = [
        {
            label: "Defining and understanding AI in cyber",
            href: "https://www.isflive.org/s/article/ai-insights-defining-and-understanding-ai-in-cyber",
            target: "_blank",
            width: "38.7%",
            height: "5%",
            left: "11%",
            top: "67.7%",
            onClick: effect("edb8e2a7-a32d-4063-a4da-92824b1eeec3")
        },
        {
            label: "Offensive AI",
            href: "https://www.isflive.org/s/article/ai-insights-offensive-and-defensive-ai",
            target: "_blank",
            width: "38.7%",
            height: "5%",
            left: "50.7%",
            top: "67.7%",
            onClick: effect("2a4529da-4164-473f-beae-0e181966314f")
        },
        {
            label: "Defensive AI",
            href : "https://www.isflive.org/s/article/ai-insights-offensive-and-defensive-ai", 
            target: "_blank",
            width: "38.7%",
            height: "5%",
            left: "11%",
            top: "73.7%",
            onClick: effect("82470ac8-fa40-4f02-91d6-d7862c9ae730")
        },
        {
            label: "Contact the author - Lee Munson",
            href: "mailto:lee.munson@securityforum.org?subject=AI Insights series",
            target: "_blank",
            isExternal: true,
            width: "38.7%",
            height: "5%",
            left: "50.7%",
            top: "73.7%",
            onClick: effect("50b6cb2c-5900-415c-b622-bda46dcfd41d")
        },
        {
            label: "Join the AI community",
            href: "https://www.isflive.org/s/topic/0TO0J00000055yOWAQ/artificial-intelligence",
            target: "_blank",
            width: "42.7%",
            height: "5%",
            left: "29%",
            top: "82%",
            onClick: effect("51c6aed0-d4e1-44ab-beb6-9343157981b6")
        },
    ].map(convertLinksUTM)

    return <MappedImage links={links} imageStyle="width:unset;" imageURL="https://assets.swoogo.com/uploads/full/4566418-67181a88777a2.png">
        <iframe src="https://player.vimeo.com/video/1023882835?autoplay=1" allowfullscreen style={{
            width: "78.4%",
            height: "48.9%",
            left: "11.1%",
            top: "15.9%",
            position: "absolute",
            border: 0
        }} allow="autoplay" />
    </MappedImage>
}

const AIMetadata = {
    name: "AI Insights",
    dismiss: {
        width: "2%",
        height: "3%",
        left: "87.5%",
        top: "10.5%"
    }
}

const SupplierRisk = () => {
    useEffect(effect("d864e537-2d13-4952-aaff-daa15293ff56"), [])
    const links = [
        {
            label: "How can the ISF help with Risk Management",
            href: "https://www.isflive.org/s/services-overview/supply-chain-management",
            target: "_blank",
            width: "84.7%",
            height: "5.1%",
            left: "7.5%",
            top: "74.7%",
            onClick: effect("42d4341c-76ff-4b00-b240-c625dd8c973c")
        },
        {
            label: "Get in touch with our experts",
            href: "mailto:services@securityforum.org?subject=ISF Services enquiry",
            target: "_blank",
            isExternal: true,
            width: "42.7%",
            height: "5%",
            left: "29%",
            top: "84%",
            onClick: effect("b36e27bc-693e-47b8-a62b-1e5ea526f867")
        },
    ].map(convertLinksUTM)

    return <MappedImage links={links} imageStyle="width:unset;" imageURL="https://assets.swoogo.com/uploads/full/4566446-67181cbe3c94a.png">
        <iframe src="https://player.vimeo.com/video/768934142?autoplay=1" allowfullscreen style={{
            width: "84.6%",
            height: "55.3%",
            left: "7.6%",
            top: "16.7%",
            position: "absolute",
            border: 0
        }} allow="autoplay" />
    </MappedImage>
}

const SRMMetadata = {
    name: "Supplier Risk Management",
    dismiss: {
        width: "2%",
        height: "3%",
        left: "90.5%",
        top: "11%"
    }
}

export default {
    day: new Date("2024-11-11 08:00:00.000-05:00"),
    tvs: [
        [AIInsights, AIMetadata],
        [ISFAssure, IAMetadata],
        [SupplierRisk, SRMMetadata],
        Podcast(1),
        membership,
        [ModalForm, {
            name: "AI Survey",
            dismiss: {
                width: "2%",
                height: "3%",
                left: "90.5%",
                top: "11%"
            },
            extras: {
                dismissHTML: "X",
                dismissStyle: dismiss
            }
        }]
    ]
}